<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// NotFound.vue?ff62ebe8